import { useEffect } from 'react';

import { H3, P2 } from '../../../styles/FontStyles';

import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../app/hooks';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { colors } from '../../../styles/GlobalStyles';
import { Overlay } from '../Overlay';
import { getMyHubsMinara } from '../Portfolio.actions';

import { MinaraItem } from './MinaraItem';

export const MinaraSummary = () => {
  const dispatch = useDispatch();

  const { minara } = useAppSelector((state) => state.portfolio);

  useEffect(() => {
    dispatch(getMyHubsMinara());
  }, [dispatch]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        dispatch(getMyHubsMinara());
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return (
    <>
      <Flexed mb='40' center between rowSM>
        <H3 mbSM='10' color={colors.primary900}>
          Minara
        </H3>
        <Button negative disabled maxWidth='250px' maxWidthSM='100%'>
          ADD MINARA
        </Button>
      </Flexed>

      <div>
        {minara?.orders?.map((item: any, index: number) => (
          <MinaraItem key={index} item={item} />
        ))}
      </div>

      {minara?.orders?.length === 0 && (
        <P2 center color={colors.neutral500}>
          No data available
        </P2>
      )}

      <Overlay />
    </>
  );
};
